import React from 'react';
import prev from '../../assets/prev.svg'
import next from '../../assets/next.svg'
import { Row, Col } from 'react-bootstrap';
import {
    Input,
} from 'reactstrap';
import './pagination.css'

const defaultButton = props => <button type='button' {...props}>{props.children}</button>;
export default class Pagination extends React.Component {
    constructor(props) {
        super(props)
        this.changePage = this.changePage.bind(this);
        this.state = {
            visiblePages: this.getVisiblePages(null, props.pages)
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.pages !== nextProps.pages) {
            const visiblePages = this.getVisiblePages(null, nextProps.pages);
            this.setState({
                visiblePages: this.filterPages(visiblePages, nextProps.pages)
            });
        }
    }

    getVisiblePages = (page, total) => {
        if (total < 5) {
            return this.filterPages([1, 2, 3, 4], total);
        } else {
            if (page % 5 >= 0 && page > 4 && page + 2 < total) {
                return [1, page - 1, page, page + 1, total];
            } else if (page % 5 >= 0 && page > 4 && page + 2 >= total) {
                return [1, total - 3, total - 2, total - 1, total];
            } else {
                return [1, 2, 3, 4, total];
            }
        }
    }

    filterPages = (visiblePages, totalPages) => {
        return visiblePages.filter(page => page <= totalPages);
    };

    changePage(page) {
        const activePage = this.props.page + 1;
        if (page === activePage) {
            return;
        }
        const visiblePages = this.getVisiblePages(page, this.props.pages);
        this.setState({
            visiblePages: this.filterPages(visiblePages, this.props.pages)
        });

        this.props.onPageChange(page - 1);
    }

    onSIzeChange = (e) => {
        this.props.onPageSizeChange(Number(e.target.value))
    }

    render() {
        const { PageButtonComponent = defaultButton } = this.props;
        const activePage = this.props.page + 1;
        const pageSize = this.props.pageSize;
        let recordsInfoText = "";
        const { filtered, sortedData, page } = this.props;
        if (sortedData && sortedData.length > 0) {
            let isFiltered = filtered.reduce((ids, val) => {
                if (val.value != "") {
                    ids.push(val);
                }
                return ids;
            }, []).length > 0;

            let totalRecords = sortedData.length;

            let recordsCountFrom = page * pageSize + 1;

            let recordsCountTo = recordsCountFrom + pageSize - 1;

            if (recordsCountTo > totalRecords) {
                recordsCountTo = totalRecords
            }
            
            if (isFiltered)
                recordsInfoText = `${recordsCountFrom}-${recordsCountTo} of ${totalRecords} filtered records`;
            else
                recordsInfoText = `${recordsCountFrom}-${recordsCountTo} of ${totalRecords} records`;
        }
        else recordsInfoText = "No records";

        return (
            <Row className="paginate table-pagination">
                <Col className="pagination-data"> Items per page</Col>
                <Col className="pagination-content-grid">
                    <Input className="row-selection-dropdown" type="select" name="pageSize" value={pageSize} onChange={this.onSIzeChange} size="1">
                        {[5, 10, 20, 25, 50, 100].map((option, i, array) => {
                            return (
                                <option key={i} value={option}>
                                    {option}
                                </option>
                            )
                        })}

                    </Input>
                </Col>
                <Col className="pagination-content-display">
                    <span className="records-data">{recordsInfoText}</span>
                </Col>
                <Col className="pagination-pages-values">
                    <div>
                        <PageButtonComponent
                            className={
                                activePage > 1
                                    ? "table-page-button"
                                    : "table-page-button disable-buttom"
                            }
                            onClick={() => {
                                if (activePage === 1) return;
                                this.changePage(activePage - 1);
                            }}
                            disabled={activePage === 1}
                        >
                            <img src={prev} alt="" />
                        </PageButtonComponent>
                    </div>
                    {this.state.visiblePages.map((page, index, array) => {
                        return (
                            <div><PageButtonComponent
                                key={page}
                                className={
                                    activePage === page
                                        ? "table-page-button table-page-button-active"
                                        : "table-page-button"
                                }
                                onClick={this.changePage.bind(null, page)}
                            >
                                {array[index - 1] + 2 < page ? `...` : page}
                            </PageButtonComponent></div>
                        );
                    })}
                    <div >
                        <PageButtonComponent
                            className={
                                activePage === this.props.pages
                                    ? "table-page-button disable-buttom"
                                    : "table-page-button "
                            }
                            onClick={() => {
                                if (activePage === this.props.pages) return;
                                this.changePage(activePage + 1);
                            }}
                            disabled={activePage === this.props.pages}
                        >
                            <img src={next} alt="" />
                        </PageButtonComponent>
                    </div>
                </Col>
            </Row>
        )
    }
}